import { EMOJI_REGEX_GLOBAL } from '../../utils/validation';

export const generatedPastedText = (
    pastedText: string,
    maxPerLine: number,
    maxLines: number,
    selectionStart: number,
    selectionEnd: number,
    value: string,
): {
    newValue: string;
    textBeforeCursor: string;
    cleanPastedText: string;
} => {
    const cleanPastedText = pastedText.replace(EMOJI_REGEX_GLOBAL, '');

    const textBeforeCursor = value.substring(0, selectionStart);
    const textAfterCursor = value.substring(selectionEnd);

    const newText = textBeforeCursor + cleanPastedText + textAfterCursor;

    const newValue = formatTextToLines(newText, maxPerLine, maxLines);

    return { newValue, textBeforeCursor, cleanPastedText };
};

export function formatTextToLines(text: string, maxPerLine: number, maxLine: number): string {
    const maxLength = maxPerLine * maxLine;
    const result: string[] = [];
    let currentLine = '';
    let totalLength = 0;

    const tokens = text.split(/([\r\n]+|\s+)/).filter(Boolean);

    tokens.some((token) => {
        if (/^[\r\n]+$/.test(token)) {
            if (currentLine.trim().length > 0) {
                result.push(currentLine.trim());
                totalLength += currentLine.trim().length;
                currentLine = '';
            }
            return false;
        }

        const word = token.replace(/\s+/, ' ');
        const newLine = currentLine ? `${currentLine}${word}` : word.trimStart();

        if (newLine.length > maxPerLine) {
            if (currentLine.trim().length > 0) {
                result.push(currentLine.trim());
                totalLength += currentLine.trim().length;
            }

            if (word.trim().length <= maxPerLine) {
                currentLine = word.trim();
            } else {
                currentLine = '';
            }
        } else {
            currentLine = newLine;
        }

        return result.length >= maxLine || totalLength + currentLine.length > maxLength;
    });

    if (currentLine.trim().length > 0 && result.length < maxLine) {
        result.push(currentLine.trim());
    }

    return result.slice(0, maxLine).join('\n');
}
